import { champsDeSource, champsDeCondition, champsNatifs, schemaDeFamille, estFamilleADecider, CHAMPS_DE_TRACE, type AppFieldsFile, type AppScreen, type SourceSimple, type Condition } from '@taki/data-model';

/** Meme controle a l'import d'une app et a la publication d'une instance. */
export function verifierChampsDEcran(champs: AppFieldsFile, ecran: AppScreen): void {
  for (const porte of ecran.portes) {
    if (!porte.jeu) continue;
    const jeu = porte.jeu;
    if (estFamilleADecider(jeu.family)) continue;
    const declares = champs.jeux.find(j => j.family === jeu.family && j.type === jeu.type)?.champs ?? [];
    const natifs = schemaDeFamille(jeu.family).shape;
    const verifier = (nom: string) => {
      const existe = nom.startsWith('socle:') ? nom.slice(6) in natifs : declares.some(c => c.key === nom) || nom in natifs;
      if (!existe) throw new Error(`La porte ${porte.label} cite le champ ${nom}, absent de son jeu`);
    };
    const condition = (c: Condition): void => {
      champsDeCondition(c).forEach(verifier);
      if ('et' in c) { c.et.forEach(condition); return; }
      if ('ou' in c) { c.ou.forEach(condition); return; }
      if (c.op === 'parmi') {
        const options = declares.find(champ => champ.key === c.champ)?.options;
        const inconnue = options === undefined ? undefined : c.valeurs.find(v => !options.some(o => o.value === v));
        if (inconnue !== undefined) throw new Error(`La porte ${porte.label} filtre ${c.champ} sur ${String(inconnue)}, absent de ses choix`);
        return;
      }
      if (c.op !== 'avantAujourdhui' && c.op !== 'moi') return;
      const declare = declares.find(champ => champ.key === c.champ);
      const genre = (natif: string) => [...champsNatifs(jeu.family), ...CHAMPS_DE_TRACE].some(champ => champ.key === c.champ.replace(/^socle:/, '') && champ.genre === natif);
      if (c.op === 'moi') {
        if (!(declare ? declare.type === 'personne' : genre('personne'))) throw new Error(`La condition moi exige un champ personne : ${c.champ}`);
        return;
      }
      const date = declare ? ['date', 'datetime'].includes(declare.type) : genre('date');
      if (!date) throw new Error(`La condition avantAujourdhui exige un champ date : ${c.champ}`);
    };
    for (const filtre of porte.filtres?.autres ?? []) if (filtre.condition) condition(filtre.condition);
    if (porte.tranche) condition(porte.tranche);
    // Le detail de porte remplace entierement celui de l'ecran.
    for (const binding of Object.values(porte.vb ?? ecran.vb)) {
      if (!binding) continue;
      // Une regle de surbrillance porte une condition, controlee comme un filtre.
      for (const regle of binding.surbrillances ?? []) if (regle.si !== 'nouveau') condition(regle.si);
      for (const [role, source] of Object.entries({ ...binding, ...binding.extra })) {
        if (role === 'extra' || !source || typeof source !== 'object' || Array.isArray(source)) continue;
        champsDeSource(source as SourceSimple).forEach(verifier);
      }
    }
  }
}
